<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
      <keep-alive>
        <router-view class="view" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    <!-- </transition> -->
    <!-- <transition :name="transitionName"> -->
      <router-view class="view" v-if="!$route.meta.keepAlive"></router-view>
    <!-- </transition> -->

<!--    <router-view></router-view>-->
  </div>
</template>

<script>
export default {
  name: 'app',
    watch: {
        '$route' (to, from) {
            let _self = this
            if (_self.routeList.length === 0) _self.routeList.push(from.name)
            if (_self.routeList.length > 1 && to.name === _self.routeList[_self.routeList.length - 2]) {
                _self.transitionName = 'prev' // 返回
                _self.routeList.splice(_self.routeList.length - 1, 1)
                return
            }
            if (_self.routeList.length > 2 && to.name === _self.routeList[_self.routeList.length - 3]) {
                _self.transitionName = 'prev' // 返回
                _self.routeList.splice(_self.routeList.length - 2, 2)
                return
            }
            _self.transitionName = 'next' // 前进
            _self.routeList.push(to.name)
        }
    },
    data () {
        return {
            transitionName: 'next',
            routeList: [],
        }
    },
}
</script>

<style>
html { font-family: "Microsoft Yahei",arial,helvetica,sans-serif; -webkit-text-size-adjust:none; word-break : break-word;}
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, a, code, em, img, q, small, strong, dd, dl, dt, li, ol, ul, fieldset, form, label, table, tbody, tr, th, td, input { margin: 0; padding: 0; outline:0;}

#app {
  height:100%;
  width:100%;
}
html{height: 100%;font-size: 62.5%}
body{position:relative;height:100%;background-color: #f2f2f2;}
a[href$="1257113351"]{width: 0;height:0;position: absolute;top: -1000px;left:-1000px;}
.hide{display: none;}
.bb{
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAABlBMVEUAAADb29tXdnSWAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjYGA4AAAAxADBPcXUKgAAAABJRU5ErkJggg==);
    background-repeat: repeat-x;
    background-position: 0 bottom;
    background-size: auto 1px,1px auto;
}
.main{display: block; position: relative;color: #666666;}
img{vertical-align:top;}
.single{line-height: 46px;}
p{font-size: 13px;color: #999999;padding-left: 6%;padding-right: 6%;}
.A0009 a,.pink a{color: #ff638e;}
a{color: #0285f0;}
.clearfix{clear: both;}
.title{color:#333333;font-weight: bold;}
.content{font-size: 12px;color: #666666;line-height: 20px;}

.model {
    display:none;    
    position: fixed;
    top: 0;
    z-index: 99999;
    background-color: rgba(0,0,0,.4);
    width: 100%;
    height: 100%;
}
.model .body {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -45%;
    margin-top: -90px;
    border-radius: 3px;
    width: 90%;
    background-color: #ffffff;
}
.model .title{font-weight: normal;padding-left: 24px;margin-top: 16px;}

.model .title,.model .foot{color: #0285f0;font-size: 17px;line-height: 34px;border: none;}
.A0009 .model .title,.A0009 .model .foot,.pink .model .title,.pink .model .foot{color: #ff638e;}
.bottom_bg{
    position: fixed;
    z-index: -1;
    width: 100%;
    height: 170px;
    bottom:0;
    width: 100%;
    background-image:url(./images/bottom_bg.png);
    background-repeat: repeat-x;
    background-position: center bottom;
    background-size: 100%;
}
.model .content{min-height: 73px;color: #484a50;font-size: 14px;line-height: 20px;padding: 0 24px 8px 24px;margin-top: 7px;}
.model .foot{text-align: center;line-height: 54px;}
.model .foot,.model .btns{
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAABlBMVEUAAADb29tXdnSWAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjYGA4AAAAxADBPcXUKgAAAABJRU5ErkJggg==);
    background-repeat: repeat-x;
    background-position: 0 top;
    background-size: auto 1px,1px auto;
    padding:0;
}
.model .cancel,.model .confirm{text-align: center;display:inline-block;width: 50%;box-sizing: border-box!important; -webkit-box-sizing: border-box!important;line-height: 46px;font-size: 17px;}
.model .cancel{}
.model .confirm{border-left: 1px #f2f2f2 solid;color: #0285f0;}
.A0009 .model .confirm,.pink .model .confirm{color: #ff638e;}
.button {
    width: 100%;
    line-height: 50px;
    font-size: 18px;
    text-align: center;
    color: #ffffff;
    background-color: #0285f0;
    padding-right: 0;
    padding-left: 0;
    margin-top:12px;
}
.A0009 .button,.pink .button{background-color: #ff638e;border:1px solid #e04a73;}
.A0009 .button:active{background-color: #e44d77;color:#f4b6c7;}
.doc_title{font-size: 13px;line-height: 20px;color: #333333;font-weight: bold;padding-top: 20px;margin-bottom: 20px;}
.doc_text{font-size: 12px;color: #666666;line-height: 1.8;margin-bottom: 10px;}
.doc_a{text-align: center;margin-top: 10px;}
.doc_a a{text-decoration: none;}

.loading {
    position: fixed;
    top: 0;
    z-index:100;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
}

.loading .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    border-radius: 3px;
    margin: -1.9rem -5.5rem;
    line-height: 3.8rem;
    width: 11rem;
    background: #fff;
    border: 1px solid #d9d9d9;
}

.loading .circle:before,.loading .circle:after {
    display: inline-block;
    vertical-align: middle
}

.loading .circle:before {
    content: ' ';
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAABR1BMVEUAAAAChfAChfAChfAChfAChfAGh/EChfAChfAChfAChfAChfAChfAChfAChfHM5/3R6f0ChfAChfAChfAChfAChfABhfAChfC12vsChfAChfAChfAChfAChfAChfAChfAChfAChfBruPYChfAChfDE4/zd7/0ChfAChfAChfAChfAEhvAChfAEhvAChfAChfAEhvENivG/4fsRjPEChfAGh/EChfAChfAChfAChfAilPIChfAChfAChfA1nvRGpvQIh/F6v/cChfCExPiQyvkChfCc0PmIxvi12/sQjPEYj/IQjPEChfAtmvMek/JAo/QChfBUrfVKqPQ9ofRfs/ZVrfUChfCm1Pqr1/sChfB7v/ik1Pp5v/cChfATjPFWrvYKifEdkvItmvMYkPEflPIwnPNesfVotvYomPIqmPKGxfhVrfUChfBsjkL4AAAAbHRSTlMA/O3r6PkF9fPaDdK8qZ0NCfHZzrOhOx4C98jCtq6RimNUTDgwFAXk4t7KmpZxS0YsIxoZEgPv3NXEjXx3dXNkXEVBPzc1Ly0hoJWRhH57a2ldWlhWUykoJSEdGxEQCwmkhXh0UkxJPTsxJQVlYMAjAAACW0lEQVRYw+2UWVvaQBSGZyYTkrCEsIusigiCbCpuSKVWAZdaq3Xfuq/f/78u9KY+LckEeLzjvZwveZ+Zc+YMmTBhwqhM3d10vn09Pz07+/K95hhBYNx2Xr2cnX33dvvNi9ebm8et2pCC+exVe3e35/ij+Hj84WC/WIoMY/Auda8u233F7Pnpdm8XB4eHejCRtl8Eb3ZpqXvZ7vy8uXv89fiw/OPzp/33oVBiI7Vs02B4e47urXfq71q9WvLEPcFCvGqvDobhzWYN8g/hxY14POC+sLWLecNrDFh/aBZibn8sYs8xPzhouQobeb1OxiG9FgiwLTIWRzywtnAxlsLh5i62SMZiJ+fXtLnxHEVpXU0RC5zibTC/FDP/7D6hJevCajBtNWwalwDMEAEpRVNOTFMPgBORYobnV5Om6TRAwyLFnJZjCdN0AVCvRYrldc6nTVMJYCsihdMlSa7nVPQPEhEexC+xgmU5MyLFXl5Sg5ZNFT6xLR+Pmg9aAxS6SJFEDiXTtAIKzSG44NMypzvmxc6BomytqFAuByymUQdF3FrhAUfSqtoQDVpZZr5VyycnCNmyGg4XODzWMwRQhMzzRUiKUhW1jFI0zNIt+BiOiKhnkIGGmUGR4HYQATW17wg5B7RcR1QCrxEhGdZ3aP/1ZWYdKgPfIzYI+0BlIFh2PDlfOQgwH6QMscW1G4gCcOnpcGRlJRJOFwOAwijcEWKTeor2JDL6/3EuqQBUnww5RYZgLiEDcpSiD5VVBVA8VTIcGX0NT/AXM2R47ivNUGyB5/2xULPiJBMmTBiR31pVa0La/gk/AAAAAElFTkSuQmCC") no-repeat center;
    background-size: contain;
    -webkit-animation: rotate 1s linear infinite;
    animation: rotate 1s linear infinite;
    height: 2.2rem;
    width: 3rem;
    margin: 0 .1rem 0 .2rem
}

.loading .circle:after {
    content: '处理中...';
    color: #777;
    font-size: 1.6rem
}
@-webkit-keyframes rotate {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0)
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

@keyframes rotate {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0)
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

.toast-shade{
    position: fixed;
    width: 100%;
    height:100%;
    top:0;
    left: 0;
    background: #000;
    opacity: 0.8;
    z-index: 1000;
}
.toast-panel{
    position: fixed;
    top:50%;
    left: 50%;
    transform:translate(-50%,-50%);
    -webkit-transform:translate(-50%,-50%);
    font-size: 16px;
    z-index: 2001;
    width: 277px;
    height: 100px;
    text-align: center;
    color: #fff;
}
.toast-panel .reload-btn{
    border: 1px solid #fff;
    width: 80px;
    padding: 3px 8px;
    margin: 0 auto;
}
.toast-panel .desc{
    line-height: 50px;
}
    
    
p{font-size: 13px;color: #999999;line-height: 46px;padding-left: 6%;padding-right: 6%;}
a{color: #0285f0;}
.detail{
    padding: 0 6%;
    font-size: 14px;
    line-height: 29px;
    margin-bottom: 15px;
    background-color: #ffffff;
}
.detail p{
    font-size: 14px;
    line-height: 46px;
    color: #666666;
    padding-left: 0;
    padding-right: 0;
}

.detail span,.detail a{
    float: right;
}
.voucherBtn{display: block;font-size: 13px;color: #0285f0;width: 100%;text-align: center;text-decoration: none;line-height: 40px;}


.small_font{font-size: 12px;}
.main{display: block; position: relative;color: #666666;margin-top: 15px; }
.title{background-color: #ffffff;padding: 0 6%;margin-bottom: 12px;}
.title .status{font-size: 14px;color: #35cc7e;width: 50%;border-top: 1px solid #f2f2f2;}
.title p{padding: 0}
.title .zhongan{font-size: 18px;color: #000;font-weight: 400;line-height: 26px;padding-top: 16px;}
.title .zhongan img{width: 24%;position: absolute;right: 3%;top: 17px}
.title .logo{
    position: absolute;
    right: 6%;
    top: 5px;
    width: 85px;
    height: 85px;
    background-image: url(./images/index/baozhang.png);
    background-repeat: no-repeat;
    background-size: 100%;
}
.limit,.block p{padding-left: 6%;}

.block{background-color: #ffffff;position: relative;margin-bottom: 15px;}
.block span,.block a{position: absolute; right: 6%}

.block p{color: #666666;}

.bottom_btn{
    text-align: center;
    display: inline-block;
    width: 100%;
    font-size: 18px;
    color: #0285f0;
    background-color: #ffffff;
    line-height: 50px;
    text-decoration: none;
    border-top:1px solid #dbdbdb;
    bottom: 0;
}

.claimList{
    box-sizing:border-box;
    -moz-box-sizing:border-box;
    -webkit-box-sizing:border-box;
    border-left: #dbdbdb solid 1px;
}
.claim .title .status{color: #f55e52;}
.claim .title .logo{background-image: url(./images/claim.png);}
    
.block input{
    position: absolute;
    left: 25%;
    width: 75%;
    overflow: hidden;
    height: 45px;
    line-height: 14px;
    font-size: 14px;
    color: #666666;
    border:none;
    background-color: transparent;
    text-indent: 10px;
    word-break: keep-all;
    white-space: nowrap;
}

.container,
.page {
  background-color: #f2f2f2;
}
.v {
  min-height: calc(100vh);
}
.change-page .v {
  position: absolute;
  top: 0;
  width: 100%;
}
/*场景切换*/
.next-leave-active,
.next-enter-active,
.prev-enter-active,
.prev-leave-active {
  position: absolute !important;
  top: 0;
  width: 100%;
}
.next-enter-active {
  z-index: 1002;
  -webkit-animation: pageFromRightToCenter 400ms forwards;
  animation: pageFromRightToCenter 400ms forward;
}
.next-leave-active {
  z-index: 1001;
  -webkit-animation: pageFromCenterToLeft 400ms forwards;
  animation: pageFromCenterToLeft 400ms forwards;
}
.prev-enter-active {
  z-index: 1002;
  -webkit-animation: pageFromLeftToCenter 400ms forwards;
  animation: pageFromLeftToCenter 400ms forward;
}
.prev-leave-active {
  z-index: 1001;
  -webkit-animation: pageFromCenterToRight 400ms forwards;
  animation: pageFromCenterToRight 400ms forwards;
}
@-webkit-keyframes pageFromRightToCenter {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@-webkit-keyframes pageFromCenterToRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
.page-from-center-to-left {
  -webkit-animation: pageFromCenterToLeft 400ms forwards;
  animation: pageFromCenterToLeft 400ms forwards;
}
.page-from-left-to-center {
  -webkit-animation: pageFromLeftToCenter 400ms forwards;
  animation: pageFromLeftToCenter 400ms forwards;
}
@-webkit-keyframes pageFromCenterToLeft {
  from {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@-webkit-keyframes pageFromLeftToCenter {
  from {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.zoom {
  -webkit-animation: zoom 0.2s cubic-bezier(0.2, 0.73, 0.71, 0.9);
}
.zoomOut {
  -webkit-animation: zoomOut 0.8s cubic-bezier(0.2, 0.73, 0.71, 0.9);
}
@-moz-keyframes pageFromRightToCenter {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@-webkit-keyframes pageFromRightToCenter {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@-o-keyframes pageFromRightToCenter {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes pageFromRightToCenter {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@-moz-keyframes pageFromCenterToRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
@-webkit-keyframes pageFromCenterToRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
@-o-keyframes pageFromCenterToRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
@keyframes pageFromCenterToRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
@-moz-keyframes pageFromCenterToLeft {
  from {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@-webkit-keyframes pageFromCenterToLeft {
  from {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@-o-keyframes pageFromCenterToLeft {
  from {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes pageFromCenterToLeft {
  from {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@-moz-keyframes pageFromLeftToCenter {
  from {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@-webkit-keyframes pageFromLeftToCenter {
  from {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@-o-keyframes pageFromLeftToCenter {
  from {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes pageFromLeftToCenter {
  from {
    opacity: 0.5;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@-moz-keyframes zoom {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@-webkit-keyframes zoom {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@-o-keyframes zoom {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@keyframes zoom {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@-moz-keyframes zoomOut {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@-webkit-keyframes zoomOut {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@-o-keyframes zoomOut {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}
@keyframes zoomOut {
  0% {
    -webkit-transform: scale(0.1) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.3) translate3d(0, 0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?16fd85b9